var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7977_21665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.07704 3.84089C6.30007 0.90947 6.14809 1.03641 6.57118 0.922446C6.68146 0.892751 6.83445 0.876306 7.01225 0.875058C7.3675 0.872588 7.65579 0.948848 7.92624 1.11689C8.18779 1.27942 13.8816 6.50596 13.954 6.65007C14.0998 6.93986 13.8817 7.30075 13.5429 7.33045C13.2822 7.35328 13.2295 7.3301 12.9208 7.05617L12.6372 6.80454V7.76385C12.6372 8.70952 12.6363 8.72474 12.5756 8.83307C12.5417 8.89351 12.4667 8.9773 12.4089 9.01927C12.3118 9.0897 12.2872 9.09558 12.0899 9.09558C11.8926 9.09558 11.8679 9.0897 11.7709 9.01927C11.713 8.9773 11.638 8.89351 11.6042 8.83307L11.5426 8.72317L11.5419 7.2624L11.5412 5.80162L9.44163 3.87483C8.28685 2.8151 7.30264 1.93077 7.25448 1.90969C7.15468 1.86599 6.92922 1.85915 6.82135 1.89656C6.78134 1.91043 5.78309 2.79474 4.60305 3.86171L2.4575 5.80162L2.45744 8.48705C2.45742 10.1992 2.46746 11.2212 2.48516 11.3069C2.5475 11.6086 2.7757 11.8761 3.08678 12.0122L3.26466 12.0901L4.11981 12.0973L4.97497 12.1046L9.07973 12.1046L9.90752 12.0974L10.7353 12.0901L10.9132 12.0122C11.2562 11.8621 11.4724 11.586 11.5213 11.2355C11.56 10.9586 11.6108 10.8446 11.7407 10.7432C11.8661 10.6454 11.9745 10.6186 12.1746 10.6361C12.3423 10.6508 12.4864 10.7474 12.5778 10.9062C12.6345 11.0046 12.6401 11.041 12.6279 11.2306C12.5905 11.8088 12.2835 12.3424 11.7889 12.6888C11.4374 12.9349 11.0802 13.0603 10.6165 13.1004C10.2369 13.1333 8.63759 13.1331 8.44749 13.1002H5.60721C5.417 13.1332 3.76333 13.1333 3.38348 13.1004C2.55601 13.0289 1.90727 12.616 1.56778 11.9447C1.36733 11.5483 1.37978 11.7253 1.36985 9.13624L1.3609 6.80621L1.07822 7.05702C0.770497 7.33002 0.717683 7.35328 0.457113 7.33045C0.117786 7.3007 -0.100833 6.93807 0.0469652 6.65007C0.0824029 6.58097 1.01509 5.71631 3.07704 3.84089Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 7,
    width: 3,
    height: 4.5,
    rx: 1,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7977_21665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2aa7e8f40763d178720b60b2e7dac4b5.svg";
export { ForwardRef as ReactComponent };